import script from "./TextureStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./TextureStudio.vue?vue&type=script&setup=true&lang=js"

import "./TextureStudio.vue?vue&type=style&index=0&id=44aa7876&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44aa7876"]])

export default __exports__